import {
  Box,
  Button,
  Link as MuiLink,
  Pagination,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TableRow,
} from '@mui/material';
import { getFillHistoryUpdateReportDownloadUrlApi } from 'api/prescription';
import { format } from 'date-fns';
import { capitalize, isEmpty, isNil, map } from 'lodash';
import { closeSnackbar, enqueueSnackbar } from 'notistack';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { handleError } from 'store/thunks/errorHandlerThunks';
import { useFillHistoryUpdateReport } from '../hooks/useFillHistoryUpdateReport';

const headCells = [{ label: 'Report Date' }, { label: 'Status' }];

const FillHistoryUpdateReportTable = () => {
  const {
    setPage,
    page: currentPage,
    fillHistoryUpdateReports,
    count,
  } = useFillHistoryUpdateReport();
  const dispatch = useDispatch();
  const totalPages = Math.ceil(count / 25);

  const handlePageChange = (_, page) => {
    if (currentPage === page) {
      return;
    }
    setPage(page);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleDownload = useCallback(
    ({ fileKey, fileName }) =>
      () => {
        const snack = enqueueSnackbar({
          message: 'Downloading...',
          variant: 'info',
          persist: true,
        });
        getFillHistoryUpdateReportDownloadUrlApi({ fileKey })
          .then((url) => {
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            // the filename you want
            a.download = `${fileName}.csv`;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            closeSnackbar(snack);
          })
          .catch((error) => dispatch(handleError({ error })));
      },
    [dispatch]
  );

  if (fillHistoryUpdateReports === null) {
    return <Box>Loading...</Box>;
  }

  if (!isNil(fillHistoryUpdateReports) && isEmpty(fillHistoryUpdateReports)) {
    return <Box>No Reports Found</Box>;
  }

  return (
    <TableContainer>
      <Table size='small' stickyHeader>
        <TableHead>
          <TableRow>
            {map(headCells, ({ label }) => (
              <TableCell key={label}>{label}</TableCell>
            ))}
          </TableRow>
        </TableHead>

        <TableBody>
          {map(fillHistoryUpdateReports, (report) => (
            <TableRow key={report.key}>
              <TableCell>
                <MuiLink
                  sx={{ py: 1 }}
                  component={Button}
                  onClick={handleDownload({
                    fileKey: report.key,
                    fileName: format(new Date(report.lastModified), 'yyyy-MM-ddyyyy'),
                  })}
                >
                  {format(new Date(report.lastModified), 'MM/dd/yyyy')}
                </MuiLink>
              </TableCell>
              <TableCell>{capitalize(report.type)}</TableCell>
            </TableRow>
          ))}
        </TableBody>

        {!isNil(fillHistoryUpdateReports) && totalPages > 1 && (
          <TableFooter sx={{ justifyContent: 'flex-end', alignItems: 'flex-end', display: 'flex' }}>
            <TableRow>
              <TableCell colSpan={8} align='right' sx={{ borderBottom: 'none' }}>
                <Pagination
                  sx={{
                    justifyContent: 'flex-end',
                    alignItems: 'flex-end',
                    display: 'flex',
                  }}
                  count={totalPages}
                  page={currentPage}
                  size='small'
                  onChange={handlePageChange}
                />
              </TableCell>
            </TableRow>
          </TableFooter>
        )}
      </Table>
    </TableContainer>
  );
};
export default FillHistoryUpdateReportTable;
